// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2Nkpk","tab":"Tabs_tab__2K30V","tabActive":"Tabs_tabActive__yNBhs"};